/**
 * ApproveRequestAccessModal Messages
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.admin.requestAccess.approveModal';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Approve request',
  },
  requestedWorkspaceLabel: {
    id: `${scope}.requestedWorkspaceLabel`,
    defaultMessage: 'Requested Workspace',
  },
  typeLabel: {
    id: `${scope}.typeLabel`,
    defaultMessage: 'Workspace',
  },
  typePlaceholder: {
    id: `${scope}.typePlaceholder`,
    defaultMessage: 'Select Workspaces',
  },
  roleLabel: {
    id: `${scope}.roleLabel`,
    defaultMessage: 'Role',
  },
  optionWorkspace: {
    id: `${scope}.option.workspace`,
    defaultMessage: 'Workspace',
  },
  optionFeature: {
    id: `${scope}.option.feature`,
    defaultMessage: 'Feature',
  },
  optionContributor: {
    id: `${scope}.option.contributor`,
    defaultMessage: 'Contributor',
  },
  optionOwner: {
    id: `${scope}.option.owner`,
    defaultMessage: 'Owner',
  },
  createUser: {
    id: `${scope}.createUser`,
    defaultMessage: 'Create user',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  finalize: {
    id: `${scope}.finalize`,
    defaultMessage: 'Finalize',
  },
});
